<template>
  <div class="">
    <div class="formBox margbot" ref="searchBox">
      <!-- 查询条件 -->
      <el-form :inline="true" :model="searchFrom" class="demo-form-inline" size="mini" label-width="100px">
        <div class="formItemBox">
          <el-form-item label="运单编号:" >
            <el-input placeholder="可支持多个" type="textarea" v-model="searchFrom.wayNo" ></el-input>
          </el-form-item>
          <el-form-item label="账单编号:">
            <el-input placeholder="可支持多个" type="textarea" v-model="searchFrom.zdh" ></el-input>
          </el-form-item>
          <el-form-item label="创建时间:" >
            <el-date-picker
              v-model="createTime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :default-time="['00:00:00', '23:59:59']"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="结算状态:">
            <el-select v-model="searchFrom.settlementStatesList" placeholder="请选择结算状态" multiple>
              <el-option v-for="item in ysSettlementList" :label="item.showName" :key="item.value"
                :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开票状态:">
            <el-select v-model="searchFrom.invoicingStates" placeholder="请选择开票状态">
              <el-option v-for="item in ysInvoicingList" :label="item.showName" :key="item.showName" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="结算客户:">
            <el-input v-model="searchFrom.payer" placeholder="请输入结算客户"></el-input>
          </el-form-item>
          <el-form-item label="业务部门:">
            <el-select v-model="searchFrom.businessSubunit" placeholder="请选择">
              <el-option label="全部" value="" ></el-option>
              <el-option v-for="item in bumenList" :label="item.name" :value="item.name" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建部门:">
            <el-select v-model="searchFrom.createSubdepartmentName" placeholder="请选择">
              <el-option label="全部" value="" ></el-option>
              <el-option v-for="item in bumenList" :label="item.name" :value="item.name" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目名称:"  >
            <el-select v-model="searchFrom.projectType" filterable placeholder="请选择">
              <el-option  label="全部" value="" ></el-option>
              <el-option v-for="item in xmList" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建人:">
            <el-input v-model="searchFrom.createUser" placeholder="请输入创建人"></el-input>
          </el-form-item>
        </div>
        <div style="">
          <el-form-item>
            <el-button type="primary" size="mini" @click="chaxun">查询</el-button>
            <el-button type="primary" size="mini" @click="chongZhi">重置</el-button>
            <el-button type="primary" size="mini" :disabled="isDisable" @click="ZDdaochuFN" v-if="btnFlg[5]" >导出</el-button>
            <el-button type="primary" size="mini" @click="delSettlementFn" v-if="btnFlg[0]">撤销对账</el-button>
            <el-button type="primary" size="mini" @click="chexiaoShouKuan" v-if="btnFlg[1]">撤销收款</el-button>
            <!-- <el-button type="primary" size="mini" @click="chexiaoKaiPiao" v-if="btnFlg[2]">撤销开票</el-button> -->
            <el-button type="primary" size="mini" @click="allPaymentFn" v-if="btnFlg[3]">一键收款</el-button>
            <el-button type="primary" size="mini" @click="allPaymentFnPL" v-if="btnFlg[6]">批量收款</el-button>
            <el-button type="primary" size="mini" @click="sqkpFN" v-if="btnFlg[4]">申请开票</el-button>
          </el-form-item>
           <el-form-item>
              <p class="margin0">收入合计:<span class="red">{{map.totalAmountSum}}</span>元</p>
            </el-form-item>
            <el-form-item label-width="120px">
              <p class="margin0">结算量:<span class="red">{{map.weight}}</span></p>
            </el-form-item>
            <el-form-item label-width="120px">
              <p class="margin0">未收款金额合计:<span class="red">{{map.noPaymentAmount}}</span>元</p>
            </el-form-item>
            <el-form-item label-width="120px">
              <p class="margin0">已收款金额合计:<span class="red">{{map.paymentAmount}}</span>元</p>
            </el-form-item>
            <el-form-item>
              <p class="margin0">已选：未收款金额<span class="red">{{yixuanJson.wskje|moneyFormatNew}}</span>元</p>
            </el-form-item>
            <el-form-item>
              <p class="margin0">待开票金额<span class="red">{{yixuanJson.dkpje|moneyFormatNew}}</span>元</p>
            </el-form-item>

        </div>
      </el-form>
    </div>
    <!--表格1-->
    <div :style="{height:h}">
      <el-table :data="tableList" ref="tableList" v-loading='loading' class="elTab" highlight-current-row @row-click="dianjixuanzhong" border height="100%" size="mini" style="width:100%"
      :header-cell-style="{background:'#F5F5F5',color:'black'}" @selection-change='selectGoods'
      >
        <el-table-column type="selection" width="50" fixed></el-table-column>
        <el-table-column type="index" width="55" label="序号" fixed></el-table-column>
        <el-table-column label="操作"  width="220">
          <template slot-scope="scope">
            <el-button type="text" size="mini" :disabled='scope.row.isDisable' @click="daochuFN(scope.row)">导出明细</el-button>
            <el-button type="text" size="mini" @click="ZDdetils(scope.row)" v-if="scope.row.settlementStates <'2'&&btnFlg[7]">收款</el-button>
            <el-button type="text" size="mini" @click="ZDdetils(scope.row)" v-if="scope.row.invoicingStates<2&&scope.row.noInvoiceAmount>0&&btnFlg[8]">申请开票</el-button>
            <el-button type="text" size="mini" :disabled='scope.row.isDisable1' @click="daochuFN1(scope.row)">对账单</el-button>
            <el-button type="text" size="mini" v-if="scope.row.settlementStates =='0'&&scope.row.invoicingStates=='0'&&btnFlg[9]" @click="bukaipiaoFN(scope.row)">不开票</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="" label="账单号" align="center" width="160">
          <template slot-scope="scope">
            <!-- <el-button type="text" @click="detilsYS(scope.row)">{{scope.row.billNo}}</el-button> -->
            <!-- <copyFiles :wayNoOrOrder='scope.row.billNo' :btnFlag='true' :btnClick='detilsYS(scope.row)'></copyFiles> -->
            <el-tooltip effect="dark" :content="scope.row.billNo" placement="right-end">
              <el-button type="text" @click="detilsYS(scope.row)">{{scope.row.billNo}}</el-button>
              <div slot="content" style="cursor: pointer;" @click="copyBtn(scope.row.billNo)">复制</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="" label="结算状态" align="center" width="100">
          <!-- 0.未收款/未付款/待确认、1.部分收款/部分付款、2.已收款/已付款/已确认 -->
          <template scope="scope">
            <span class="wsStyle" v-show="scope.row.settlementStates == '0'">未收款</span>
            <span class="bfStyle" v-show="scope.row.settlementStates == '1'">部分收款</span>
            <span class="ysStyle" v-show="scope.row.settlementStates == '2'">已收款</span>
            <span class="ysStyle" v-show="scope.row.settlementStates == '3'">不收款</span>
          </template>
        </el-table-column>
        <el-table-column prop="" label="开票状态" align="center" width="100">
          <template scope="scope">
            <!-- 0.未开票、1.开票中.已开票 -->
            <span class="wsStyle" v-show="scope.row.invoicingStates == '0'">未开票</span>
            <span class="bfStyle" v-show="scope.row.invoicingStates == '1'">开票中</span>
            <span class="ysStyle" v-show="scope.row.invoicingStates == '2'">已开票</span>
            <span class="ysStyle" v-show="scope.row.invoicingStates == '3'">不开票</span>
          </template>
        </el-table-column>
        <el-table-column prop="payer" label="结算客户" align="center" width="300">
        </el-table-column>
        <el-table-column prop="projectType" label="项目名称" width="160"> </el-table-column>
        <el-table-column prop="wayNumber" label="运单数量" align="center" width="90">
        </el-table-column>
        <el-table-column prop="totalAmount" label="收入合计(元)" align="center" width="120">
        </el-table-column>
        <el-table-column prop="" label="已收款金额(元)" align="center" width="130">
          <template slot-scope="scope">
            <span style="color: #0c46a2;cursor: pointer;" @click="getShouKuanFn(scope.row)">{{scope.row.paymentAmount}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="noPaymentAmount" label="未收款金额(元)" align="center" width="130">
        </el-table-column>
        <el-table-column prop="" label="已开票金额(元)" align="center" width="130">
          <template slot-scope="scope">
            <span style="color: #0c46a2;cursor: pointer;" @click="getYiKaiPiaoFn(scope.row)">{{scope.row.invoiceAmount}}</span>
          </template>
        </el-table-column>
         <el-table-column prop="" label="待开票金额(元)" align="center" width="130">
          <template slot-scope="scope">
            <span style="color: #0c46a2;cursor: pointer;" @click="getDaiKaiPiaoFn(scope.row)">{{scope.row.invoiceApplyAmount}}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="noInvoiceAmount" label="未开票金额(元)" align="center" width="130">
        </el-table-column> -->
        <el-table-column prop="noInvoiceAmount" label="待申请开票金额(元)" align="center" width="150">
        </el-table-column>
        <el-table-column prop="businessSubunit" label="业务部门" width="130" show-overflow-tooltip >
        </el-table-column>
        <el-table-column prop="createSubdepartmentName" label="创建部门" width="130" show-overflow-tooltip >
        </el-table-column>
        <el-table-column prop="createUser"  label="创建人" width="170"></el-table-column>
        <el-table-column prop="createTime" :formatter="dateTimeFormat" label="创建时间" width="170"></el-table-column>
      </el-table>
    </div>
    <!--分页-->
    <div>
      <el-pagination
        background
        @current-change="handleCurrentChangeA"
        :current-page="searchFrom.pageNo"
        :page-size="searchFrom.pageSize"
        :page-sizes="[25,50,100]"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChangeA"
        :total="total"
      ></el-pagination>
    </div>
    <!-- 申请开票 -->
    <shenqingkaipiao  v-if="SQkaiPiaoMark" :SQkaiPiaoMark.sync='SQkaiPiaoMark' :SQkaiPiaoFrom='kaiPiaoFrom' :detilsFlag = 'false'></shenqingkaipiao>
    <!-- 一键收款 -->
    <yiJianShouKuan v-if="shouKuanMark" :shouKuanMark.sync='shouKuanMark' :shouKuanFrom='shouKuanFrom' @refresh = 'getList' :detilsFlag = 'false'></yiJianShouKuan>
    <!-- 点击已收金额弹窗 -->
    <yiShoujinE v-if="SKJLMark" :SKJLMark.sync='SKJLMark' :shouKuanJL='shouKuanJL' @refresh = 'getList'></yiShoujinE>
    <!-- 一键开票 -->
    <yiJianKaiPiao v-if="kaiPiaoMark" :kaiPiaoMark.sync='kaiPiaoMark' :kaiPiaoFrom='kaiPiaoFrom' @refresh = 'getList' :detilsFlag = 'false'></yiJianKaiPiao>
    <!-- 点击已开票金额弹窗 -->
    <yiKaiPiaojinE v-if="KPJLMark" :KPJLMark.sync='KPJLMark' :kaiPiaoJL='kaiPiaoJL' @refresh = 'getList'></yiKaiPiaojinE>
    <!-- 点击账单号 -->
    <yingShouDetil v-if="yingShouDetilsMark" :yingShouDetilsMark.sync='yingShouDetilsMark'
      :ysSettlementBillId = 'ysSettlementBillId'></yingShouDetil>

       <!-- 批量收款 -->
    <piLiangShouKuan v-if="PLshouKuanMark" :PLshouKuanMark.sync='PLshouKuanMark' :plskArr='plskArr'
    @refresh = 'getList' ></piLiangShouKuan>
  </div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import { getSettlementBillList, delSettlementBill, getDictionaryDetailList, invoiceApplyForYsBillList, getSettlementBillListTotal, noInvoiceSettlementBill } from '@/api/newTMS'
import { getCurrUserDepartment } from '@/api/newCrm'
import { emptyFn, dateTimeFormat, dateFormat1, getLastMonth } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import yiJianShouKuan from '@/views/newTMS/publicFiles/caiWuYingShou/yiJianShouKuan.vue'
import piLiangShouKuan from '@/views/newTMS/publicFiles/caiWuYingShou/piLiangShouKuan.vue'
import yiShoujinE from '@/views/newTMS/publicFiles/caiWuYingShou/yiShoujinE.vue'
import yiJianKaiPiao from '@/views/newTMS/publicFiles/caiWuYingShou/yiJianKaiPiao.vue'
import yiKaiPiaojinE from '@/views/newTMS/publicFiles/caiWuYingShou/yiKaiPiaojinE.vue'
import yingShouDetil from '@/views/newTMS/publicFiles/caiWuYingShou/yingShouDetil.vue'
import shenqingkaipiao from '@/views/newTMS/publicFiles/caiWuYingShou/shenqingkaipiao.vue'
export default {
  name: 'Freight',
  components: {
    yiJianShouKuan,
    yiShoujinE,
    yiJianKaiPiao,
    yiKaiPiaojinE,
    yingShouDetil,
    shenqingkaipiao,
    piLiangShouKuan
  },
  data () {
    return {
      dateTimeFormat: dateTimeFormat,
      shouKuanMark: false,
      loading: false,
      ysSettlementList: [
        {
          showName: '全部',
          value: ''
        },
        {
          showName: '未收款',
          value: '0'
        },
        {
          showName: '部分收款',
          value: '1'
        },
        {
          showName: '已收款',
          value: '2'
        },
        {
          showName: '不收款',
          value: '3'
        }
      ],
      ysInvoicingList: [
        {
          showName: '全部',
          value: ''
        },
        {
          showName: '未开票',
          value: '0'
        },
        {
          showName: '开票中',
          value: '1'
        },
        {
          showName: '已开票',
          value: '2'
        },
        {
          showName: '不开票',
          value: '3'
        }
      ],
      emptyFn: emptyFn,
      h: '500px',
      xuanzhongArr: [],
      // 查询条件
      createTime: [],
      searchFrom: {
        insideOutsideType: 1,
        paymentFlag: 0,
        pageNo: 1, // 页数
        pageSize: 50 // 条数
      },
      total: 0,
      // 按钮
      btnFlg: [],
      btnIdArr: ['01N00I0200', '01N00I0300', '01N00I0400', '01N00I0500', '01N00I0600', '01N00I0D00', '01N00I0F00', '01N00I0700', '01N00I0800', '01N00I0G00'],
      tableList: [],
      SKJLMark: false,
      shouKuanJL: {
        pageNo: 1, // 页数
        pageSize: 50, // 条数
        settlementBillId: ''
      },
      shouKuanFrom: {},
      kaiPiaoMark: false,
      kaiPiaoFrom: {},
      KPJLMark: false,
      kaiPiaoJL: {
        pageNo: 1, // 页数
        pageSize: 50, // 条数
        settlementBillId: ''
      },
      yingShouDetilsMark: false,
      ysSettlementBillId: '',
      SQkaiPiaoMark: false,
      bumenList: [],
      isDisable: false,
      map: {
        totalAmountSum: 0,
        weight: 0,
        noPaymentAmount: 0
      },
      xmList: [],
      yixuanJson: { wskje: 0.00, dkpje: 0.00 },
      plskArr: [],
      PLshouKuanMark: false
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/yingShouSettlement')
    this.createTime = getLastMonth()
    getCurrUserDepartment().then(res => { this.bumenList = res })
    getDictionaryDetailList({ dictionaryType: 'project_type' }).then(res => { this.xmList = res })
    this.getList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight // 头部搜索盒子高度
    let pH = document.documentElement.clientHeight // 浏览器高度
    this.h = pH - h - 210 + 'px'
    // 218 ->页面除盒子外的高度
  },
  methods: {
    // 不开票
    bukaipiaoFN (row) {
      this.$confirm('是否需要将该账单的结算状态设为“不收款”，开票状态设为“不开票”？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        noInvoiceSettlementBill({
          id: row.id
        }).then(res => {
          loading.close()
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          this.getList()
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {})
    },
    // 选择数据
    selectGoods (selection) {
      this.yixuanJson.wskje = 0.00
      this.yixuanJson.dkpje = 0.00
      selection.forEach((item, index) => {
        this.yixuanJson.wskje += item.noPaymentAmount
        this.yixuanJson.dkpje += item.invoiceApplyAmount
      })
    },
    // 账单导出
    async ZDdaochuFN () {
      this.isDisable = true
      if (this.searchFrom.settlementStatesList && this.searchFrom.settlementStatesList.length == 0) {
        this.$set(this.searchFrom, 'settlementStatesList', null)
      }
      if (this.createTime) {
        if (this.createTime.length > 0) {
          this.$set(this.searchFrom, 'createTime', this.createTime)
        }
      } else {
        this.$set(this.searchFrom, 'createTime', null)
      }
      if (this.searchFrom.wayNo) {
        this.searchFrom.wayNos = this.searchFrom.wayNo.replace(/\n/g, ',')
      } else {
        this.searchFrom.wayNos = ''
      }
      if (this.searchFrom.zdh) {
        let zdh = this.searchFrom.zdh.replace(/\n/g, ',')
        let zdhArr = zdh.split(',')
        if (zdhArr.length == 1) {
          this.searchFrom.billNo = zdhArr[0]
        } else {
          this.searchFrom.billNos = zdhArr
        }
      } else {
        this.searchFrom.billNos = null
        this.searchFrom.billNo = ''
      }
      let form = { ...this.searchFrom }
      delete form.pageNo
      delete form.pageSize
      await exportExcel(
        this.global.tmsPlus + '/settlementBill/exportSettlementBillList',
        form,
        '应收账单列表'
      )
      this.isDisable = false
    },
    // 申请开票
    sqkpFN () {
      let selectData = this.$refs.tableList.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
        return
      }
      let jiesuankehu = selectData[0].payer
      let flag = selectData.every(item => item.payer == jiesuankehu)
      let flag1 = selectData.every(item => item.invoicingStates < 2)
      let flag2 = selectData.every(item => item.noInvoiceAmount != 0)
      if (!flag) {
        this.$alert('只能选择同一结算客户未开票、开票中且待申请开票金额不为0状态的账单！', '系统提示')
        return
      }
      if (!flag1) {
        this.$alert('只能选择同一结算客户未开票、开票中且待申请开票金额不为0状态的账单！', '系统提示')
        return
      }
      if (!flag2) {
        this.$alert('只能选择同一结算客户未开票、开票中且待申请开票金额不为0状态的账单！', '系统提示')
        return
      }
      let ids = selectData.map(item => item.id)
      this.kaiPiaoFrom.ids = ids.toString()
      this.SQkaiPiaoMark = true
    },
    // 复制
    copyBtn (message) {
      // navigator.clipboard.writeText 该方法需要在安全域下才能够使用，比如：https 协议的地址、127.0.0.1、localhost
      navigator.clipboard
        .writeText(message)
        .then(() => {
          this.$message.success('复制成功')
        })
        .catch((err) => {
        // 复制失败
          console.error('复制失败')
        })
    },
    // 获取列表
    getList () {
      this.loading = true
      if (this.searchFrom.settlementStatesList && this.searchFrom.settlementStatesList.length == 0) {
        this.$set(this.searchFrom, 'settlementStatesList', null)
      }
      if (this.createTime) {
        if (this.createTime.length > 0) {
          this.$set(this.searchFrom, 'createTime', this.createTime)
        }
      } else {
        this.$set(this.searchFrom, 'createTime', null)
      }
      if (this.searchFrom.wayNo) {
        this.searchFrom.wayNos = this.searchFrom.wayNo.replace(/\n/g, ',')
      } else {
        this.searchFrom.wayNos = ''
      }
      if (this.searchFrom.zdh) {
        let zdh = this.searchFrom.zdh.replace(/\n/g, ',')
        let zdhArr = zdh.split(',')
        if (zdhArr.length == 1) {
          this.searchFrom.billNo = zdhArr[0]
        } else {
          this.searchFrom.billNos = zdhArr
        }
      } else {
        this.searchFrom.billNos = null
        this.searchFrom.billNo = ''
      }
      getSettlementBillList(this.searchFrom).then(res => {
        this.loading = false
        this.tableList = res.list
        this.total = res.total
      })
      getSettlementBillListTotal(this.searchFrom).then(res => {
        this.map = res
      })
    },
    // 点击选中需要修改的行
    dianjixuanzhong (row) {
      this.xuanzhongArr = []
      this.xuanzhongArr = row
    },
    // 查询
    chaxun () {
      this.getList()
    },
    // 重置
    chongZhi () {
      this.searchFrom = {
        insideOutsideType: 1,
        paymentFlag: 0,
        pageNo: 1, // 页数
        pageSize: 50 // 条数
      }
      this.createTime = getLastMonth()
      this.getList()
    },
    // 表格分页
    handleCurrentChangeA (val) {
      this.searchFrom.pageNo = val
      this.getList()
    },
    handleSizeChangeA (val) {
      this.searchFrom.pageSize = val
      this.getList()
    },
    // 账单详情
    ZDdetils (row) {
      this.$router.push({ name: 'ZDdetils', query: { ysSettlementBillId: row.id, settlementPattern: row.settlementPattern, makeTicketYn: row.makeTicketYn, payee: row.payer } })
    },
    // 点击账单号
    detilsYS (row) {
      this.yingShouDetilsMark = true,
      this.ysSettlementBillId = row.id
    },
    // 点击一键收款
    allPaymentFn () {
      let selectData = this.$refs.tableList.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else if (selectData.length > 1) {
        this.$alert('请选择一条要操作的数据', '系统提示')
      } else {
        if (selectData[0].settlementStates == '2' || selectData[0].settlementStates == '3') {
          this.$alert('只能选择未收款或部分收款的数据', '系统提示')
          return
        }
        // this.shouKuanFrom = {}
        // this.imgList = []
        this.shouKuanFrom.collectionAmount = selectData[0].noPaymentAmount
        this.$set(this.shouKuanFrom, 'settlementBillId', selectData[0].id)
        this.$set(this.shouKuanFrom, 'recordType', 0)
        this.$set(this.shouKuanFrom, 'pendingAmount', selectData[0].noPaymentAmount)
        this.shouKuanMark = true
        // 参数 以下都必填
        // settlementBillId 账单表主键id
        // recordType 传固定值 0 （记录类型 0.收款、1.部分收款 ）
        // pendingAmount 收款金额（待收金额）
        // collectionAmount 收款金额（收款金额）
        // collectionTime 收款时间 日期类型
      }
    },
    // 批量收款
    allPaymentFnPL () {
      let selectData = this.$refs.tableList.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else {
        let flag = selectData.some(item => item.settlementStates == '2' || item.settlementStates == '3')
        if (flag) {
          this.$alert('只能选择未收款或部分收款的数据', '系统提示')
          return
        }
        this.plskArr = []
        selectData.forEach(itme => {
          this.plskArr.push({
            collectionAmount: itme.noPaymentAmount,
            settlementBillId: itme.id,
            pendingAmount: itme.noPaymentAmount,
            recordType: 0
          })
        })
        this.PLshouKuanMark = true
      }
    },
    // 点击一键开票
    allInvoiceFn () {
      let selectData = this.$refs.tableList.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else if (selectData.length > 1) {
        this.$alert('请选择一条要操作的数据', '系统提示')
      } else {
        if (selectData[0].invoicingStates == '2' || selectData[0].invoicingStates == '3') {
          this.$alert('只能选择未开票或部分开票的数据', '系统提示')
          return
        }
        this.$set(this.kaiPiaoFrom, 'invoiceAmount', selectData[0].noInvoiceAmount)
        this.$set(this.kaiPiaoFrom, 'settlementBillId', selectData[0].id)
        this.$set(this.kaiPiaoFrom, 'recordType', 0)
        this.$set(this.kaiPiaoFrom, 'pendingAmount', selectData[0].noInvoiceAmount)
        this.kaiPiaoMark = true
        // 参数 以下都必填
        // settlementBillId 账单表主键id
        // invoiceNo 发票号码
        // recordType 传固定值 0 （记录类型 0.收款、1.部分收款 ）
        // pendingAmount 开票金额（待开金额）
        // invoiceAmount 开票金额（开票金额）
        // invoiceTime 开票时间 日期类型
      }
    },
    // 点击已收款金额
    getShouKuanFn (row) {
      if (row.settlementStates == '0') {
        this.$alert('只能选择已收款或者部分收款的数据', '系统提示')
      } else {
        this.shouKuanJL.settlementBillId = row.id
        this.SKJLMark = true
      }
    },
    // 待开票金额
    getDaiKaiPiaoFn (row) {
      if (row.invoiceApplyAmount == '0') {
        this.$alert('只能选择待开票金额大于0的数据', '系统提示')
      } else {
        this.kaiPiaoJL.settlementBillId = row.id
        this.kaiPiaoJL.isDaikai = true
        this.KPJLMark = true
      }
    },
    // 点击已开票金额
    getYiKaiPiaoFn (row) {
      if (row.invoiceAmount == '0') {
        this.$alert('只能选择开票金额大于0的数据', '系统提示')
      } else {
        this.kaiPiaoJL.settlementBillId = row.id
        this.kaiPiaoJL.isDaikai = false
        this.KPJLMark = true
      }
    },
    // 点击撤销收款
    chexiaoShouKuan () {
      let selectData = this.$refs.tableList.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else if (selectData.length > 1) {
        this.$alert('请选择一条数据进行操作', '系统提示')
      } else {
        if (selectData[0].settlementStates == '0' || selectData[0].settlementStates == '3') {
          this.$alert('只能选择已收款或者部分收款的数据', '系统提示')
        } else {
          this.shouKuanJL.settlementBillId = selectData[0].id
          this.SKJLMark = true
        }
      }
    },
    // 点击撤销开票
    chexiaoKaiPiao () {
      let selectData = this.$refs.tableList.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else if (selectData.length > 1) {
        this.$alert('请选择一条数据进行操作', '系统提示')
      } else {
        if (selectData[0].invoicingStates == '0') {
          this.$alert('只能选择已开票或者部分开票的数据', '系统提示')
        } else {
          this.kaiPiaoJL.settlementBillId = selectData[0].id
          this.KPJLMark = true
        }
      }
    },
    // 撤销对账
    delSettlementFn () {
      let selectData = this.$refs.tableList.selection
      if (selectData.length == 0) {
        this.$alert('请选择要操作的数据', '系统提示')
      } else if (selectData.length > 1) {
        this.$alert('请选择一条数据进行操作', '系统提示')
      } else {
        // 未收款、未开票、不收款、不开票
        if ((selectData[0].settlementStates != 0 || selectData[0].invoicingStates != 0) && (selectData[0].settlementStates != 3 || selectData[0].invoicingStates != 3)) {
          this.$alert('只能选择未收款且未开票的账单撤销', '系统提示')
        } else {
          this.$confirm('是否执行操作?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const loading = this.$loading({
              lock: true,
              text: '正在处理...'
            })
            delSettlementBill({
              id: selectData[0].id
            }).then(res => {
              loading.close()
              this.$message({
                message: '撤销成功',
                type: 'success'
              })
              this.getList()
            }).catch(error => {
              this.$message({
                showClose: true,
                message: error.message,
                type: 'error',
                onClose () {
                  loading.close()
                }
              })
            })
          }).catch(() => {})
        }
      }
    },
    // 导出
    daochuFN (row) {
      this.$set(row, 'isDisable', false)
      let from = {
        ysSettlementBillId: row.id
      }
      exportExcel(
        this.global.tmsPlus + '/settlementBill/exportOutsideYsWayList',
        from,
        '应收明细列表'
      )
      this.$set(row, 'isDisable', true)
      setTimeout(() => {
        this.$set(row, 'isDisable', false) // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 对账单
    daochuFN1 (row) {
      this.$set(row, 'isDisable1', false)
      let from = {
        ysSettlementBillId: row.id
      }
      exportExcel(
        this.global.tmsPlus + '/settlementBill/exportBillWayBusiness',
        from,
        '对账单列表'
      )
      this.$set(row, 'isDisable1', true)
      setTimeout(() => {
        this.$set(row, 'isDisable1', false) // 点击一次时隔两秒后才能再次点击
      }, 2000)
    }
  },
  activated () {
    this.$route.meta.isBack = false
    this.getList()
  }
}
</script>
<style lang="scss" scoped>
/deep/.el-form{
  width: 100%;
}
.inpBox .el-date-editor{
  width: 420px!important;
}
.box{
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill,270px);
  grid-auto-flow: row dense;
  .item1{
    grid-row-start: span 2;
  }
  .item2{
    grid-column-start: span 2;
    width: 540px;
  }
}
</style>
